import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus('');

    try {
      const res = await fetch('/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();

      if (data.success) {
        setStatus('Message sent. We will be in touch.');
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus('Something went wrong. Please try again.');
      }
    } catch {
      setStatus('Something went wrong. Please try again.');
    }

    setSending(false);
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-bg-element" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/contact-bg.png)` }}></div>
      <div className="section-inner">
        <div className="contact-layout">
          <div className="contact-info">
            <h2 className="section-title">Let&rsquo;s Talk</h2>
            <p>
              Partnership inquiries, licensing discussions, or questions about
              context-aware AI architecture. We build things that work. Let's
              talk about what you need built.
            </p>
            <a href="mailto:caelsereith@aetherprotocols.com" className="contact-email">
              caelsereith@aetherprotocols.com
            </a>
            <div className="contact-detail">Hamilton, Alabama</div>
            <div className="contact-detail">nexusconcordat.com</div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit" className="btn-gold" disabled={sending}>
              {sending ? 'Sending...' : 'Send Message'}
            </button>
            {status && (
              <div className={`form-status ${status.includes('sent') ? 'success' : 'error'}`}>
                {status}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
